/**
 * Redux Action Creators
 */

import { ROOT_ACTIONS } from './rootReducer';

export const setLanguage = (language) => ({
  type: ROOT_ACTIONS.SET_LANGUAGE,
  payload: language,
});

export const setCurrentPage = (page) => ({
  type: ROOT_ACTIONS.SET_CURRENT_PAGE,
  payload: page,
});

export const setSessionId = (sessionId) => ({
  type: ROOT_ACTIONS.SET_SESSION_ID,
  payload: sessionId,
});

export const setVerificationState = (state) => ({
  type: ROOT_ACTIONS.SET_VERIFICATION_STATE,
  payload: state,
});

export const logEvent = (eventType, eventData = {}) => ({
  type: ROOT_ACTIONS.LOG_EVENT,
  payload: {
    eventType,
    eventData,
    timestamp: new Date().toISOString(),
  },
});